import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import api from "../../services/api";
import { Toast } from "../../shared/Toast";
import { useNavigate } from "react-router";
import { CreativeContext } from "./CreativeCreation";

function WebViewAd({
  companyName,
  company,
  handleshow,
  // advId,
  creative_name,
  creative_type,
  subtype,
  editdata,
  flag,
  handlesubmit,
  createdEdited,
}) {
  const navigate = useNavigate();

  const { preview, setPreview } = useContext(CreativeContext);
  const [progress, setProgress] = useState(0);
  const [image, setImage] = useState()
  const [imageUrl, setImageUrl] = useState("")

  const [creativeurl, setcreativeurl] = useState("");
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onSubmit" });

  let watchcreativeurl = watch("creativeurl", "");

  useEffect(() => {
    if (watchcreativeurl !== false) {
      setcreativeurl(watchcreativeurl);
      setPreview({ ...preview, creativeurls: watchcreativeurl });
    } else {
      setPreview({ ...preview, creativeurls: "" });
    }
  }, [watchcreativeurl]);

  useEffect(() => {
    if (flag === "edit") {
      setPreview({
        ...preview,
        sub_type: editdata.sub_type,
        img_urls: editdata.video_urls,
      });
    }
  }, [company]);

  const onSubmit = async (data) => {
    if (flag === "add") {
      handlesubmit(true);
      let obj = {
        company_id: company,
        // adv_id: advId,
        company_name: companyName,
        creative_name,
        creative_type,
        sub_type: subtype,
        creativeurl: creativeurl,
        imageUrl,
        bl_version:data.version
      };
      // if (advId !== "" && creative_name !== "") {
      if (creative_name !== "") {
        try {
          let res = await api({
            url: `/creatives/web/webviewad`,
            method: "POST",
            responseType: "json",
            data: obj,
          });
          if (res?.code === 200) {
            Toast("success", " Creative Created Successfully  ");
            handleshow(false);
            createdEdited(true);
          } else {
            Toast("error", res.data.message);
          }
        } catch (error) {
          console.error(error);
          if (error.response.status === 401) navigate("/");
        }
      }
    } else if (flag === "edit") {
      let obj = {
        creative_name: creative_name,
        creative_type: editdata.creative_type,
        creative_id: editdata.creative_id,
        sub_type: editdata.sub_type,
        bl_version : data.version,
      };
      creativeurl !== ""
        ? (obj.creativeurl = creativeurl)
        : (obj.creativeurl = editdata.video_urls);
        imageUrl !== ""
        ? (obj.imageUrl = imageUrl)
        : (obj.imageUrl = editdata.img_urls);
      try {
        let res = await api({
          url: `/creatives/web/editwebviewad`,
          method: "POST",
          responseType: "json",
          data: obj,
        });
        if (res?.code === 200) {
          Toast("success", " Creative Edited Successfully  ");
          handleshow(false);
          createdEdited(true);
        } else {
          Toast("error", res.data.message);
        }
      } catch (error) {
        console.error(error);
        if (error.response.status === 401) navigate("/");
      }
    }
  };

  const handleImage = (e)=>{
    try {
      if (e.target.files && e.target.files.length > 0) {
        if (
          e.target.files[0].type === "image/jpg" ||
          e.target.files[0].type === "image/jpeg" ||
          e.target.files[0].type === "image/webp" ||
          e.target.files[0].type === "image/png"
        ) {
          setImage(e.target.files[0]);
        } else {
          Toast("error", "Only jpg, jpeg, webp, png formats accepted");
          setValue("image", "");
        }
      } else {
        if (flag === "edit") {
          setImageUrl(editdata.img_urls);
          setPreview({ ...preview, img_urls: editdata.img_urls });
        } else {
          setProgress(0);
          setImageUrl("");
          setPreview({ ...preview, img_urls: "" });
        }
      }
    } catch (error) {
      console.error(error)
    }
  }

  const formData1 = new FormData();
  formData1.append("files", image);
  const imageUpload = async () => {
    try {
      let url = await api({
        url: `/upload/webviewImage`,
        method: "POST",
        responseType: "json",
        data: formData1,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (data) => {
          setProgress(Math.round((100 * data.loaded) / data.total));
        },
      });
      if (url.code === 200) {
        setImageUrl(url.data.data);
        // setPreview({ ...preview, img_urls: url.data.data });
      } else {
        setProgress(0);
        setValue("image", null);
        setImage("");
        Toast("error", url.data.message);
      }
    } catch (error) {
      Toast("error", error);
    }
  }

  useEffect(()=>{
    if(image)
    imageUpload()
  },[image])
  return (
    <>
      <div className="row">
        <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
          <div className="row">
            <section className="col-12">
              <div className="row mb-3">
                <div className="col">
                  <label className="form-label">Enter Creative URL</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue={editdata.video_urls}
                    name="creativeurl"
                    {...register("creativeurl", {
                      required: "Please enter a URL.",
                      pattern: {
                        value: /^(?!.*\.(mp4|avi|mov|wmv|flv|mkv|webm|mp3|wav|ogg|jpg|jpeg|png|gif|bmp)(\?.*)?$)(https?:\/\/)?([\w.-]+)\.[a-z]{2,6}(\/[\w\-./?=&%]*)?$/i,
                        message: "Enter proper URL, Media URL's and Invalid URL's are not allowed",
                      },
                    })}
                  />
                  {errors.creativeurl && (
                    <p className="text-red-600">{errors.creativeurl.message}</p>
                  )}
                </div>
              </div>
              <div className="row mb-3">
                <div className="col">
                  <label className="form-label">Upload Image</label>
                  <input
                    type="file"
                    className="form-control"
                    name="creativeImg"
                    {...register("creativeImg", {
                      required: editdata.img_urls === "" ? true : false,
                      onChange: (e) => handleImage(e)
                    })}
                  />
                  {editdata.img_urls === "" && errors.creativeImg && (
                    <p className="text-red-600">{"Image is required!"}</p>
                  )}
                  <p>{imageUrl || editdata.img_urls}</p>
                </div>
              </div>
              <div className="row mx-2">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" defaultChecked={editdata?.bl_version === 1 ? true  : false} value="" {...register("version", {
                    required:false
                  })} />
                  <label class="form-check-label" for="flexCheckDefault">
                   Below Verson 8.4.0
                  </label>
                </div>
              </div>

              <div className="my-3 text-end">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={progress > 0 && progress < 100 ? true : false}
                >
                  Save Creative
                </button>
              </div>
            </section>
          </div>
        </form>
      </div>
    </>
  );
}

export default WebViewAd;
